export function exclusiveRighttoBuyListingContract2026CB() {
return [   // Release 2025-12-29 15:10:09
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 285.72,
   left: 474.6,
   width: 114.96,
   height: 13.92
}
,
{
   page: 0,
   name: "Radiobutton BrokerRelationship Buyer Agency", 
   isText: false,
   type: "checkbox",
   top: 265.56,
   left: 168.84,
   width: 11.28,
   height: 11.935
}
,
{
   page: 0,
   name: "Radiobutton BrokerRelationship Transaction Brokerage", 
   isText: false,
   type: "checkbox",
   top: 265.56,
   left: 286.92,
   width: 11.28,
   height: 11.935
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 492.349,
   left: 107.215,
   width: 470.520,
   height: 13.920
}
,
{
   page: 0,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 528.109,
   left: 111.535,
   width: 466.200,
   height: 13.920
}
,
{
   page: 0,
   name: "Property Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 560.948,
   left: 49.0911,
   width: 543.3839,
   height: 97.927
}
,
{
   page: 0,
   name: "Checkbox Lease of Property", 
   isText: false,
   type: "checkbox",
   top: 709.3891,
   left: 95.8145,
   width: 10.0805,
   height: 10.0800
}
,
{
   page: 1,
   name: "Date Listing Begins", 
   fontSize: 9,
   type: "date",
   top: 78.695,
   left: 394.131,
   width: 90.000,
   height: 12.600
}
,
{
   page: 1,
   name: "Date Listing Ends", 
   fontSize: 9,
   type: "date",
   top: 105.383,
   left: 69.073,
   width: 66.872,
   height: 13.490
}
,
{
   page: 1,
   name: "TextDate Listing Ends", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 104.095,
   left: 139.175,
   width: 263.236,
   height: 13.910
}
,
{
   page: 1,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 251.375,
   left: 281.811,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 251.375,
   left: 328.371,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Checkbox Buyer Agency Only", 
   isText: false,
   type: "checkbox",
   top: 470.735,
   left: 108.291,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Amount A fee equal to", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 396.24,
   left: 210.96,
   width: 45.00,
   height: 13.56
}
,
{
   page: 2,
   name: "of the purchase price or", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 396.24,
   left: 379.44,
   width: 80.04,
   height: 13.56
}
,
{
   page: 2,
   name: "See  23 Additional Provisions or", 
   isText: false,
   type: "checkbox",
   top: 442.68,
   left: 77.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 453.36,
   left: 129.24,
   width: 455.76,
   height: 12.36
}
,
{
   page: 2,
   name: "Retainer Fee Buyer will pay Brokerage Firm a nonrefundable retainer fee of", 
   isText: false,
   type: "checkbox",
   top: 575.4,
   left: 95.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "due and payable", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 571.68,
   left: 446.52,
   width: 75.00,
   height: 13.56
}
,
{
   page: 2,
   name: "Will", 
   isText: false,
   type: "checkbox",
   top: 588.6,
   left: 316.68,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Will Not be credited against other fees payable to", 
   isText: false,
   type: "checkbox",
   top: 588.6,
   left: 367.8,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Other Compensation", 
   isText: false,
   type: "checkbox",
   top: 617.88,
   left: 95.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "undefined", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 614.28,
   left: 210.72,
   width: 369.96,
   height: 13.56
}
,
{
   page: 2,
   name: "Amount", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 654.72,
   left: 148.56,
   width: 90.00,
   height: 13.56
}
,
{
   page: 2,
   name: "per square", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 654.72,
   left: 287.4,
   width: 150.0,
   height: 13.56
}
,
{
   page: 2,
   name: "or", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 669.12,
   left: 78.36,
   width: 300.00,
   height: 10.68
}
,
{
   page: 2,
   name: "See  23 Additional Provisions or_2", 
   isText: false,
   type: "checkbox",
   top: 684.6,
   left: 182.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Other_2", 
   isText: false,
   type: "checkbox",
   top: 684.6,
   left: 354.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "undefined_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 680.88,
   left: 397.32,
   width: 180.00,
   height: 13.56
}
,
{
   page: 2,
   name: "Other_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 695.4,
   left: 129.6,
   width: 449.88,
   height: 13.56
}
,
{
   page: 2,
   name: "Check Box385", 
   isText: false,
   type: "checkbox",
   top: 456.22,
   left: 77.2367,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 3,
   name: "If the", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 68.16,
   left: 67.56,
   width: 474.96,
   height: 11.88
}
,
{
   page: 3,
   name: "Lease executed after the date of this Buyer Listing Contract contains an option to extend or renew or if Buyer expands into", 
   isText: false,
   type: "checkbox",
   top: 96.6,
   left: 501.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "a fee upon exercise of such extension or renewal option or expansion If Brokerage Firm is to be paid a fee for such extension", 
   isText: false,
   type: "checkbox",
   top: 96.6,
   left: 450.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "undefined_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 134.16,
   left: 67.56,
   width: 515.04,
   height: 11.88
}
,
{
   page: 3,
   name: "entitled to receive additional compensation bonuses or incentives from sellers brokerage firm seller or any other source unless", 
   isText: false,
   type: "checkbox",
   top: 243.72,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "calendar days after the Listing Period expires Holdover Period 1 if the Property is one on which", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 319.2,
   left: 116.28,
   width: 49.92,
   height: 11.88
}
,
{
   page: 3,
   name: "Radiobutton AgreementWithOtherBroker Is", 
   isText: false,
   type: "checkbox",
   top: 476.04,
   left: 265.713,
   width: 10.080,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton AgreementWithOtherBroker Is Not", 
   isText: false,
   type: "checkbox",
   top: 476.04,
   left: 302.673,
   width: 10.080,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton ReceivedListOfSubmittedProperty Has", 
   isText: false,
   type: "checkbox",
   top: 499.08,
   left: 50.1927,
   width: 10.0801,
   height: 10.08
}
,
{
   page: 3,
   name: "Radiobutton ReceivedListOfSubmittedProperty Has Not", 
   isText: false,
   type: "checkbox",
   top: 499.08,
   left: 98.6727,
   width: 10.0803,
   height: 10.08
}
,
{
   page: 4,
   name: "undefined_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 242.64,
   left: 261.12,
   width: 320.04,
   height: 11.64
}
,
{
   page: 4,
   name: "undefined_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 267.84,
   left: 59.28,
   width: 519.96,
   height: 11.64
}
,
{
   page: 4,
   name: "Brokerage Services", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 146.001,
   left: 51.6729,
   width: 542.0751,
   height: 73.054
}
,
{
   page: 4,
   name: "Radiobutton GrantDisclosureBuyersIdentity Does", 
   isText: false,
   type: "checkbox",
   top: 288.338,
   left: 291.873,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "Radiobutton GrantDisclosureBuyersIdentity Does Not", 
   isText: false,
   type: "checkbox",
   top: 288.338,
   left: 342.993,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 612.96,
   left: 211.32,
   width: 369.96,
   height: 10.68
}
,
{
   page: 6,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 106.355,
   left: 38.4679,
   width: 556.4741,
   height: 331.212
}
,
{
   page: 6,
   name: "ChecklistItem Attachments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 451.59,
   left: 41.8074,
   width: 550.5836,
   height: 59.964
}
,
{
   page: 7,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 204.976,
   left: 105.467,
   width: 469.680,
   height: 14.160
}
,
{
   page: 7,
   name: "Buyer 1 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 241.896,
   left: 114.107,
   width: 465.000,
   height: 14.160
}
,
{
   page: 7,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.776,
   left: 114.107,
   width: 170.040,
   height: 14.160
}
,
{
   page: 7,
   name: "Buyer 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.776,
   left: 408.587,
   width: 169.920,
   height: 14.160
}
,
{
   page: 7,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 273.776,
   left: 114.107,
   width: 465.000,
   height: 14.040
}
,
{
   page: 7,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 296.696,
   left: 105.467,
   width: 469.680,
   height: 14.160
}
,
{
   page: 7,
   name: "Buyer 2 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 334.736,
   left: 114.107,
   width: 465.000,
   height: 14.040
}
,
{
   page: 7,
   name: "Buyer 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 349.736,
   left: 114.107,
   width: 170.040,
   height: 14.160
}
,
{
   page: 7,
   name: "Buyer 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 349.736,
   left: 408.587,
   width: 169.920,
   height: 14.160
}
,
{
   page: 7,
   name: "Buyer 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 364.736,
   left: 114.107,
   width: 465.000,
   height: 14.040
}
,
{
   page: 7,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 387.656,
   left: 105.467,
   width: 469.680,
   height: 14.160
}
,
{
   page: 7,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 429.656,
   left: 105.467,
   width: 469.680,
   height: 14.160
}
,
{
   page: 7,
   name: "Buyer Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 472.908,
   left: 115.69,
   width: 462.219,
   height: 12.836
}
,
{
   page: 7,
   name: "Buyer Broker Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 490.3,
   left: 129.489,
   width: 349.800,
   height: 12.72
}
,
{
   page: 7,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 509.599,
   left: 135.981,
   width: 342.437,
   height: 12.836
}
,
{
   page: 7,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 528.7,
   left: 82.0891,
   width: 175.0799,
   height: 12.72
}
,
{
   page: 7,
   name: "Buyer Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 557.5,
   left: 220.049,
   width: 349.920,
   height: 12.72
}
,
{
   page: 7,
   name: "Buyer Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 573.645,
   left: 220.049,
   width: 349.920,
   height: 12.720
}
,
{
   page: 7,
   name: "Buyer Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 594.9,
   left: 182.489,
   width: 350.040,
   height: 12.72
}
,
{
   page: 7,
   name: "Buyer Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 608.34,
   left: 182.489,
   width: 350.040,
   height: 12.72
}
,
{
   page: 7,
   name: "Buyer Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 623.868,
   left: 182.932,
   width: 350.040,
   height: 12.720
}
,
{
   page: 7,
   name: "Buyer CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 658.563,
   left: 142.932,
   width: 349.800,
   height: 12.720
}
,
{
   page: 7,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 678.011,
   left: 150.133,
   width: 343.091,
   height: 11.527
}
,
{
   page: 7,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 696.3081,
   left: 80.5322,
   width: 175.0798,
   height: 12.7200
}
] }
